<template>
  <div>
    <h1>页面没有找到 !</h1>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped lang="less">
  h1 {
    margin: 30px;
  }
</style>
